/* FB | Urun Vitrini yatay konum koruma (KOK COZUM). ADDITIVE; bolum dosyasina dokunmaz.
   SORUN: mobilde sayfayi DIKEY kaydirinca tarayici adres cubugu acilip/kapanir -> 'resize' tetiklenir
   (sadece YUKSEKLIK degisir, genislik AYNI). Bolumun resize handler'i window[initFPS_<id>]() cagirir
   -> fixOnRestore() -> slider.scrollLeft = 0 yapip vitrini ilk urune (BASA) atiyordu.
   KOK COZUM: bolumun global init fonksiyonlarini (initFPS_*) sar; mobilde GENISLIK ayniyken
   (yani sadece adres cubugu) cagriyi ATLA -> scrollLeft sifirlanmaz, kullanicinin konumu korunur.
   Gercek genislik/oryantasyon degisiminde orijinal davranis AYNEN calisir (init/marquee yeniden kurulur).
   ILK yukleme cagrisi orijinal referansla yapildigi icin etkilenmez (sadece resize yolu sarilir).
   EK GUVENLIK: sifirlama baska bir yoldan yine olursa, genislik ayniyken eski yatay konumu geri yaz. */
(function(){
  'use strict';
  if(window.__fbFpsScrollGuard) return; window.__fbFpsScrollGuard=true;
  var BP=750;

  /* 1) KOK: initFPS_* global init fonksiyonlarini sar */
  var wrapW=window.innerWidth;
  function wrapInits(){
    var keys;
    try{ keys=Object.keys(window); }catch(e){ return; }
    for(var n=0;n<keys.length;n++){
      var key=keys[n];
      if(key.indexOf('initFPS_')!==0) continue;
      var fn;
      try{ fn=window[key]; }catch(e){ continue; }
      if(typeof fn!=='function' || fn.__fbWrapped) continue;
      (function(k, orig){
        var wrapped=function(){
          var w=window.innerWidth;
          if(w<BP && w===wrapW){ return; }   /* mobil + sadece yukseklik (adres cubugu) -> calistirma */
          wrapW=w;
          return orig.apply(this, arguments);
        };
        wrapped.__fbWrapped=true;
        wrapped.__fbOrig=orig;
        try{ window[k]=wrapped; }catch(e){}
      })(key, fn);
    }
  }
  wrapInits();
  setTimeout(wrapInits, 300);
  setTimeout(wrapInits, 1200);
  try{ document.addEventListener('shopify:section:load', function(){ setTimeout(wrapInits, 30); }); }catch(e){}

  /* 2) EK GUVENLIK (yedek): sifirlama yine olursa, mobil + genislik ayniyken eski konumu geri yaz */
  var guardW=window.innerWidth;
  window.addEventListener('resize', function(){
    var w=window.innerWidth;
    var changed=(w!==guardW); guardW=w;
    if(w>=BP || changed) return;          /* sadece mobil + sadece yukseklik (adres cubugu) */
    var sliders=document.querySelectorAll('.fps-slider-container');
    if(!sliders.length) return;
    var saved=[], any=false;
    for(var i=0;i<sliders.length;i++){ var s=sliders[i].scrollLeft||0; saved.push(s); if(s>0) any=true; }
    if(!any) return;
    var t0=Date.now();
    (function restore(){
      for(var i=0;i<sliders.length;i++){ if(saved[i]>0 && sliders[i].scrollLeft===0){ sliders[i].scrollLeft=saved[i]; } }
      if(Date.now()-t0<600){ try{ requestAnimationFrame(restore); }catch(e){} }
    })();
  }, {passive:true});
})();